window.ShortTransferForm = {
  init: function () {
    this.$form = $('#short-transfer-form');
    if (this.$form.length === 0) return;
    this.$transportTypesBlock = $('#transport_types_block');
    this.showHideTransportTypesBlock()
    this.$form.on('submit', this.sendToAnalitics)
  },

  showHideTransportTypesBlock () {
    this.$form.bind(
      'transfer_type_changed point_changed duration_changed points_inited',
      () => {
        if (
          TransferForm.isAllPoints() ||
          TransferForm.pointPositions()[0] && TransferForm.isHourly()
        ) {
          this.$transportTypesBlock.show(TransferForm.animationDuration)
        } else {
          this.$transportTypesBlock.hide(TransferForm.animationDuration)
        }
      }
    );
  },

  sendToAnalitics () {
    try {
      gtag('event', 'calculate1', { event_action: 'calculate' });
    } catch (e) {}
    try {
      gtYaCounter('reachGoal', 'calculate-yandex');
    } catch (e) {}
    try {
      window.uetq = window.uetq || [];
      window.uetq.push({
        ec: 'calculate-bing1',
        ea: 'calculate-bing2',
        el: 'calculate-bing3',
        ev: 1
      });
    } catch (e) {}
    return true;
  }
};
